import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();
  const [showFloatingButton, setShowFloatingButton] = useState(false);

  const handleReservation = () => {
    navigate('/reservation');
  };

  // 스크롤 이벤트 리스너
  useEffect(() => {
    const handleScroll = () => {
      // 페이지의 전체 높이
      const scrollHeight = document.documentElement.scrollHeight;
      // 현재 스크롤 위치 + 화면 높이
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;

      // 하단 200px 이내에 도달하면 버튼 표시
      const isNearBottom = scrollHeight - (scrollTop + windowHeight) <= 200;
      setShowFloatingButton(isNearBottom);
    };

    // 스크롤 이벤트 등록
    window.addEventListener('scroll', handleScroll);

    // 초기 실행 (페이지 로드 시)
    handleScroll();

    // 클린업
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-brand">Re-born, ANEW</div>
          <h1 className="hero-title">
            어제보다 더 어린 오늘,<br />
            다시 피어나는 피부
          </h1>
          <p className="hero-subtitle">
            당신의 피부 시간을 되돌리는<br />
            1:1 퍼스널 리프팅 케어
          </p>
          <Button variant="primary" size="large" onClick={handleReservation}>
            지금 예약하기
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator">
          <span>SCROLL</span>
          <div className="scroll-line"></div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="about-section">
        <div className="section-header">
          <h2 className="section-title">ANEW의 핵심 가치</h2>
          <p className="section-subtitle">당신을 위한 특별한 케어 시스템</p>
        </div>
        <div className="about-container">
          <div className="about-item">
            <div className="about-number">01</div>
            <div className="value-tag">Precision</div>
            <h3 className="about-title">정교함</h3>
            <p className="about-description">
              단순한 관리가 아닌, 당신만을 위한<br />
              <strong>1:1 맞춤형 리프팅 설계</strong><br />
              피부 상태를 정밀 분석하여<br />
              개인별 최적의 솔루션을 제공합니다.
            </p>
          </div>

          <div className="about-item">
            <div className="about-number">02</div>
            <div className="value-tag">Revival</div>
            <h3 className="about-title">회복</h3>
            <p className="about-description">
              <strong>수분으로 채우고 리프팅으로 세우는</strong><br />
              피부 자생력 회복 프로그램<br />
              속건조와 탄력 저하를 동시에 해결하는<br />
              심층 수분 레이어링 + 커스텀 라인 디자인
            </p>
          </div>

          <div className="about-item">
            <div className="about-number">03</div>
            <div className="value-tag">Privacy</div>
            <h3 className="about-title">프라이빗</h3>
            <p className="about-description">
              <strong>오직 나만을 위해 준비된</strong><br />
              원장님의 집중 케어 시간<br />
              완벽한 프라이버시가 보장되는 공간에서<br />
              진정한 나를 위한 투자를 경험하세요.
            </p>
          </div>
        </div>
      </section>

      {/* Target Solution Section */}
      <section className="solution-section">
        <div className="solution-content">
          <h2 className="solution-title">지금이 피부 관리의 골든타임</h2>

          <div className="problem-solution-wrapper">
            <div className="problem-box">
              <h3 className="box-title">이런 고민, 있으신가요?</h3>
              <ul className="problem-list">
                <li>거울을 볼 때마다 깊어지는 <strong>팔자주름과 심부볼</strong></li>
                <li>수분 크림을 발라도 계속되는 <strong>속건조와 잔주름</strong></li>
                <li>바쁜 일상 속 스트레스로 <strong>탄력을 잃어가는 피부</strong></li>
                <li>값비싼 제품을 써도 <strong>눈에 띄는 변화가 없는 현실</strong></li>
              </ul>
            </div>

            <div className="solution-box">
              <h3 className="box-title">ANEW의 솔루션</h3>
              <ul className="solution-list">
                <li>
                  <strong>심층 수분 레이어링 공법</strong><br />
                  <span className="sub-text">단순 팩이 아닌, 피부 깊숙이 수분을 채워 넣는 전문 기술</span>
                </li>
                <li>
                  <strong>커스텀 라인 디자인</strong><br />
                  <span className="sub-text">기기 관리와 원장님 수기 테크닉의 결합으로 탄력 라인 설계</span>
                </li>
                <li>
                  <strong>1:1 퍼스널 케어</strong><br />
                  <span className="sub-text">당신의 피부 상태에 최적화된 맞춤형 집중 관리</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="expert-message">
            <p className="expert-text">
              "피부 탄력이 급격히 감소하는 시기에는<br />
              <strong>수분과 리프팅을 동시에 관리</strong>하지 않으면,<br />
              나중에는 회복이 어려워집니다.<br />
              <br />
              ANEW는 단순히 저렴한 관리가 아닌,<br />
              <strong>'나를 위한 투자'</strong>로서의 확실한 변화를 제공합니다."
            </p>
            <p className="expert-signature">- ANEW 원장</p>
          </div>

          <Button variant="outline" size="large" onClick={handleReservation}>
            변화를 경험하러 가기
          </Button>
        </div>
      </section>

      {/* Location Section */}
      <section className="location-section">
        <div className="location-content">
          <h2 className="location-title">오시는 길</h2>
          <div className="location-info">
            <p className="location-address">
              서울특별시 강남구 논현동<br />
              신사역 도보 10분
            </p>
            <p className="location-notice">
              * 정확한 주소는 예약 확정 후 카카오톡으로 안내드립니다.
            </p>
          </div>
        </div>
      </section>

      {/* Floating Button - 하단 도달 시에만 표시 */}
      {showFloatingButton && (
        <Button className="floating-button" variant="primary" size="medium" onClick={handleReservation}>
          <span>예약하기</span>
        </Button>
      )}
    </div>
  );
}

export default LandingPage;
